import PublishIcon from '@mui/icons-material/Publish';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const DeployIcon = (props: SvgIconProps) => <PublishIcon {...props} />;
export default DeployIcon;
